import { DSModal } from "@components/design-system/organisms";

const ConfirmAbandonEditsModal = ({
  shouldShow,
  hideModal,
  confirmAction,
}) => (
  <DSModal
    isOpen={shouldShow}
    onClose={hideModal}
    title="Quit Template Builder?"
    actions={[
      { label: "Cancel", variant: "cancel", onClick: hideModal },
      {
        label: "Confirm",
        variant: "primary",
        onClick: confirmAction,
        dataTestId: "confirm-button",
      },
    ]}
    dataTestId="confirm-abandon-edits-modal"
  >
    <p>
      Are you sure you want to exit the Template Builder?{" "}
      <b>You will lose any unsaved changes.</b>
    </p>
    <p>Are you sure you want to proceed?</p>
  </DSModal>
);

export default ConfirmAbandonEditsModal;
